var map = {
	"./affaere1/puzzle-white-icon.svg": 12145,
	"./affaerentreff/puzzle-white-icon.svg": 8987,
	"./casualxdates/puzzle-white-icon.svg": 88532,
	"./ficktreffpunkt24/puzzle-white-icon.svg": 96482,
	"./fremdgehboerse/puzzle-white-icon.svg": 378,
	"./illicitoasis/puzzle-white-icon.svg": 21585,
	"./puzzle-white-icon.svg": 61079,
	"./seitensprungtreff69/puzzle-white-icon.svg": 37433
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 42461;